"use strict";

import initModulesInScope from "@elements/init-modules-in-scope";

export function initInScope ($scope) {
    let product = $(".js-change-modal__product");
    let btnOpenSizeTable = $(".js-change-modal__open-size-table");
    let btnCloseSizeTable = $(".js-change-modal__close-size-table");
    let sizeTable = $(".js-change-modal__size-table");
    let btnCloseProduct = $('.js-change-modal__close-product');

    btnCloseSizeTable.addClass('d-none');

    btnOpenSizeTable.on('click', function(){
        sizeTable.removeClass('d-none');
        btnCloseSizeTable.removeClass('d-none')
        product.addClass('d-none');
    })

    btnCloseSizeTable.on('click', function(){
        product.removeClass('d-none');
        sizeTable.addClass('d-none');
        btnCloseSizeTable.addClass('d-none');
    })

    btnCloseProduct.on('click', function(e){
        $(".js-change-modal").modal('hide');
    })


    //sends correct data to cart & adapts data in modal
    $scope.find(".js-change-modal__radio-input").on("change", function(radio){
        let radioButton = radio.currentTarget;

        if(radioButton.checked){
            $scope.find(".js-change-modal__hidden-input").attr('value', radioButton.value);
            setSizeRowTitle(radioButton);
            let available = radioButton.getAttribute('data-available');

            let btnTextAvailableSoon = $scope.find('.js-change-modal__btn-text--available-soon');
            let btnTextUnavailable = $scope.find('.js-change-modal__btn-text--unavailable');
            let btnTextAvailable = $scope.find('.js-change-modal__btn-text--available');

            if(available == 'availableSoon'){
                btnCloseProduct[0].disabled = true;
                btnTextAvailableSoon.removeClass('d-none');
                btnTextUnavailable.addClass('d-none');
                btnTextAvailable.addClass('d-none');
            }else if(available == 'unavailable'){
                btnCloseProduct[0].disabled = true;
                btnTextUnavailable.removeClass('d-none');
                btnTextAvailable.addClass('d-none');
                btnTextAvailableSoon.addClass('d-none');
            } else if (available == 'available') {
                btnCloseProduct[0].disabled = false;
                btnTextUnavailable.addClass('d-none');
                btnTextAvailable.removeClass('d-none');
                btnTextAvailableSoon.addClass('d-none');
            }
        }
    })
}

/**
 * Sets the size row title to the selected size
 * @param {HTMLElement} radioButton
 */
const setSizeRowTitle = (radioButton) => {
    const sizeRow = radioButton.closest('.js-size-picker-row');
    const sizeRowTitle = sizeRow.querySelector('.js-change-modal__size');
    sizeRowTitle.textContent = radioButton.dataset.detailsize;

    resetOtherSizeRows(radioButton);
}

/**
 * Resets the size row title of the other size rows
 * @param {HTMLElement} radioButton
 */
const resetOtherSizeRows = (radioButton) => {
    const sizePicker = radioButton.closest('.js-size-picker');
    const sizeRows = sizePicker.querySelectorAll('.js-size-picker-row');
    const pickedSizeRowId = radioButton.getAttribute('data-size-row-id');

    sizeRows.forEach(row => {
        if(row.getAttribute('data-size-row-id') != pickedSizeRowId){
            const sizeRowTitle = row.querySelector('.js-change-modal__size');
            sizeRowTitle.textContent = '';
        }
    })

}

